<script lang="ts">
    export let fill:string = "white";

</script>

<div class="svg-box">
    <svg class="svg-content" width="100%" height="100%" {fill} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5883 2.99988C11.5883 2.99988 5 9.98839 5 14.4116C5 18.0821 7.91778 20.9999 11.5883 20.9999C15.2588 20.9999 18.1766 18.0821 18.1766 14.4116C18.1766 9.98839 11.5883 2.99988 11.5883 2.99988ZM11.5883 19.3528C8.81708 19.3528 6.64707 17.1828 6.64707 14.4116C6.64707 12.1016 9.32603 8.16756 11.5891 5.47954C13.8522 8.16509 16.5295 12.0958 16.5295 14.4116C16.5295 17.1828 14.3595 19.3528 11.5883 19.3528Z" />
    </svg>    
</div>